import { createApi } from '@reduxjs/toolkit/query/react'
import { addImagesSlice } from '../slices/images';
import axiosBaseQuery from './API'

// Define a service using a base URL and expected endpoints
export const photoApi = createApi({
  reducerPath: 'photoApi',
  baseQuery: axiosBaseQuery({ baseUrl: process.env.REACT_APP_API_KEY }),
  endpoints: (builder) => ({
    addMultipleImages: builder.mutation<any, Partial<any>>({
      query(body) {        
        return {
          url: `upload/multiple`,
          method: 'POST',
          data:body,
        }
      },
      async onQueryStarted(_, {dispatch, queryFulfilled}) {
        try {
          const {data} = await queryFulfilled;          
          dispatch(addImagesSlice(data))
        } catch (err) {}
      }
    }),
    addImages: builder.mutation<any, any>({
      query(body) {        
        return {
          url: `upload/single`,
          method: 'POST',
          data:body,
        }
      },
      async onQueryStarted(_, {dispatch, queryFulfilled}) {
        try {
          const {data} = await queryFulfilled
          dispatch(addImagesSlice(data))
        } catch (err) {}
      }
    }), 
  }),
  
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useAddImagesMutation, useAddMultipleImagesMutation } = photoApi
